import React from "react";
import { useTranslation } from "react-i18next";
import AmpArrowTooltip from "../../common/AmpArrowTooltip/AmpArrowTooltip";
import Toc from "../../Toc/Toc";
import { Link } from "react-router-dom";
import AmpButton from "../../common/AmpButton/AmpButton";
import { DefaultRegTabProps } from "../RegistrationTypes";
import addSuperScript from "../../../utils/superscript";

export default function TocReg(props: DefaultRegTabProps) {
    const { t } = useTranslation('login');

    return (
        <>
            <AmpArrowTooltip title={t('toc-arrow-tooltip-title') as string} items={[t('toc-arrow-tooltip-body') as string]} className="toc-tooltip" />
            <div className="dark-blue-background">
                {addSuperScript(t('1-toc-top-text') as string)}
            </div>
            <Toc showTitle={true} />
            <div className="login-container-footer">
                <Link rel="noreferrer noopener" target="_blank" className="amp-anchor" to="/auth/contact-us">{t("need-help") as string}</Link>
                <div>
                    <AmpButton type="cancel" onClick={() => props.triggerCancel(true)} text={t("cancel")} />
                    <AmpButton type="submit" onClick={() => props.setActiveTab(2)} text={t("agree")} />
                </div>
            </div>
        </>
    )
}